import "./NewsAgendaPPZone.module.css";
import Header from "@/reusable_sections/Header";
import ZonaPPWartaHero from "./sections/ZonaPPWartaHero";
import Zonappactivities from "./sections/Zonappactivities";
import Footer from "@/reusable_sections/Footer";
export default function NewsAgendaPPZonePage() {
  return <div>
      <Header />
      <ZonaPPWartaHero />
      <Zonappactivities />
      <Footer />
    </div>;
}